import React from "react";

const CartIcon = ({ stroke, ...props }) => {
  stroke = stroke || "url(#paint0_linear_11077_29984)";
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_11077_29984)">
        <path
          d="M6.66634 18.3337C7.12658 18.3337 7.49967 17.9606 7.49967 17.5003C7.49967 17.0401 7.12658 16.667 6.66634 16.667C6.2061 16.667 5.83301 17.0401 5.83301 17.5003C5.83301 17.9606 6.2061 18.3337 6.66634 18.3337Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8333 18.3337C16.2936 18.3337 16.6667 17.9606 16.6667 17.5003C16.6667 17.0401 16.2936 16.667 15.8333 16.667C15.3731 16.667 15 17.0401 15 17.5003C15 17.9606 15.3731 18.3337 15.8333 18.3337Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.70801 1.70801H3.37467L5.59134 12.058C5.67266 12.4371 5.88357 12.7759 6.18777 13.0162C6.49197 13.2565 6.87043 13.3833 7.25801 13.3747H15.408C15.7873 13.3741 16.1551 13.2441 16.4505 13.0062C16.746 12.7683 16.9515 12.4368 17.033 12.0663L18.408 5.87467H4.26634"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_11077_29984"
          x1="5.87502"
          y1="17.5003"
          x2="7.49259"
          y2="17.4891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_11077_29984"
          x1="15.042"
          y1="17.5003"
          x2="16.6596"
          y2="17.4891"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_11077_29984"
          x1="2.12902"
          y1="7.54155"
          x2="18.3362"
          y2="7.38023"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#249373" />
          <stop offset="1" stopColor="#0071C5" />
        </linearGradient>
        <clipPath id="clip0_11077_29984">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default CartIcon;
